module.exports = __webpack_public_path__ + "img/bg_avatar_male_78.83df3c6c.png";